import $ from "jquery";

const postFiltering = () => {
    let currentIDFilter = [];

    function fetchFilteredResults(
        page = 1,
        updateUrl = true,
        shouldScroll = true
    ) {
        const currentUrl = document.location.origin;
        const params = {};

        // Add selected filters
        if (currentIDFilter.length > 0) {
            params["cat"] = currentIDFilter;
        }

        params["paged"] = page;
        params["action"] = "filter_posts";

        const finalQueryString = formatQueryString(params);

        $.ajax({
            url: currentUrl + "/wp-admin/admin-ajax.php",
            type: "GET",
            data: finalQueryString,
            dataType: "json",
            beforeSend: function () {},
            success: function (response) {
                $(".js-post-listing").html(
                    response.posts || "<p>No results found.</p>"
                );
                $(".js-post-pagination").html(response.pagination || "");

                $(".js-current-page").text(response.current_page);
                $(".js-total-pages").text(response.total_pages);
                $(".js-total-results").text(response.total_results);

                if (shouldScroll) {
                    const scrollTarget = $(".js-post-listing-top");
                    if (scrollTarget.length) {
                        $("html, body").animate(
                            {
                                scrollTop: scrollTarget.offset().top - 10,
                            },
                            500
                        );
                    }
                }

                if (updateUrl) {
                    updateUrlParams(params);
                }

                // Reattach pagination click handlers
                $(".js-post-pagination a")
                    .off("click")
                    .on("click", function (e) {
                        e.preventDefault();
                        if ($(this).hasClass("disabled")) return;

                        const pageParam = $(this)
                            .attr("href")
                            .split("paged=")[1];
                        const page = pageParam ? parseInt(pageParam) : 1;
                        fetchFilteredResults(page);
                    });
            },
            error: function (xhr, status, error) {
                console.error("AJAX Error:", status, error);
                $(".js-post-listing").html(
                    "<p>There was an error loading results.</p>"
                );
            },
        });
    }

    function formatQueryString(params) {
        const queryArray = [];
        Object.keys(params).forEach((key) => {
            if (Array.isArray(params[key])) {
                const encoded = params[key].map((val) =>
                    encodeURIComponent(val)
                );
                queryArray.push(`${key}=${encoded.join(",")}`);
            } else {
                queryArray.push(`${key}=${encodeURIComponent(params[key])}`);
            }
        });
        return queryArray.join("&");
    }

    function updateUrlParams(params) {
        delete params["action"];

        const allowedParams = ["paged", "cat"];
        const filteredParams = {};

        Object.keys(params).forEach(function (key) {
            if (allowedParams.includes(key)) {
                filteredParams[key] = params[key];
                if (key === "paged") {
                    filteredParams[key] = String(filteredParams[key]).replace(
                        /\D/g,
                        ""
                    );
                }
            }
        });

        const newUrl =
            window.location.pathname + "?" + formatQueryString(filteredParams);
        history.pushState(null, "", newUrl);
    }

    function applyFiltersFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("paged") || 1;
        const catParam = urlParams.get("cat") || "";

        currentIDFilter = [];

        let hasFilters = false;

        if (catParam.length > 0) {
            hasFilters = true;
            currentIDFilter = catParam.split(",");
            currentIDFilter.forEach((id) => {
                $(`.js-post-filter-button[data-id="${id}"]`).addClass(
                    "is-active"
                );
            });
        }

        if (page > 1) {
            hasFilters = true;
        }

        fetchFilteredResults(page, false, hasFilters); // Only scroll if filters exist
    }

    // Filter button toggles
    $(".js-post-filter-button").on("click", function () {
        const id = $(this).attr("data-id");
        const isActive = $(this).hasClass("is-active");

        if (isActive) {
            currentIDFilter = currentIDFilter.filter((i) => i !== id);
            $(this).removeClass("is-active");
        } else {
            currentIDFilter.push(id);
            $(this).addClass("is-active");
        }

        fetchFilteredResults(); // This ensures "last deselected" case also triggers AJAX
    });

    // Handle browser back/forward
    window.addEventListener("popstate", function () {
        applyFiltersFromUrl();
    });

    // Init
    applyFiltersFromUrl();
};

export default postFiltering;
